var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbnailView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 0C5.44772 0 5 0.447715 5 1V7C5 7.55229 5.44772 8 6 8H12C12.5523 8 13 7.55229 13 7V1C13 0.447715 12.5523 0 12 0H6ZM18 10H0V12H18V10ZM0 13H18V15H0V13ZM18 16H0V18H18V16Z",
    fill: "#313131"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbnailView);
export default __webpack_public_path__ + "static/media/ThumbnailView.9aed94ee88f100deb0fd214527adf5b0.svg";
export { ForwardRef as ReactComponent };